import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import { UpdateInvestigationDashboardPreferencesCommand } from './update-investigation-dashboard-preferences.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationDashboardPreferencesUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(command: UpdateInvestigationDashboardPreferencesCommand): Observable<void> {
    return this._repository.updatePreferences(command);
  }
}
